<div class="flex h-screen w-full flex-row">
  <!-- Left: cover image (hidden on small screens) -->
  <div class="hidden sm:block flex-1 relative overflow-hidden">
    <img class="absolute inset-0 w-full h-full object-cover" src="/assets/images/bg-login.jpg" alt="" />
    <!-- subtle dark gradient so the panel edge stays readable -->
    <div class="absolute inset-0 bg-gradient-to-r from-transparent to-black/20"></div>
  </div>

  <!-- Right: login panel -->
  <div class="relative flex flex-col w-full sm:w-[420px] shrink-0 bg-syn-surface">
    <!-- Language switch -->
    <div class="absolute top-4 right-4 z-10 flex flex-row">
      <div class="flex justify-center items-center hover:cursor-pointer space-x-2">
        <app-language-switch></app-language-switch>
        <app-theme-switch></app-theme-switch>
      </div>
    </div>

    <!-- Centered form content -->
    <div class="flex flex-col flex-1 items-center justify-center px-10 py-12 gap-8">
      <!-- Logo + app name -->
      <div class="flex flex-col items-center gap-2">
        <img alt="Logo" class="h-10" src="/assets/images/logo-blue.svg" />
        <span [title]="appVersion" class="text-neutral-500 text-lg">
          {{ appName }}
        </span>
      </div>

      <!-- Form -->
      <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" autocomplete="on" class="flex flex-col w-full gap-4">
        <syn-validate on="live" [customValidationMessage]="validationMessageService.byName(loginForm, 'identifier')">
          <syn-input
            [label]="'login.identifier' | translate"
            [title]="'login.identifier' | translate"
            type="text"
            name="identifier"
            formControlName="identifier"
            autocomplete="username"
            required
          >
          </syn-input>
        </syn-validate>

        <syn-validate on="live" [customValidationMessage]="validationMessageService.byName(loginForm, 'password')">
          <syn-input
            [label]="'login.password' | translate"
            [title]="'login.password' | translate"
            type="password"
            name="password"
            formControlName="password"
            autocomplete="current-password"
            passwordToggle
            required
          >
          </syn-input>
        </syn-validate>

        <syn-button variant="filled" type="submit" [disabled]="disableSubmitForm" style="width:100%">
          <syn-icon slot="prefix" name="login" aria-hidden="true"></syn-icon>
          {{ 'login.login' | translate }}
        </syn-button>

        <!-- <button
          type="button"
          (click)="redirectPasswordForgot()"
          class="text-sm text-primary-600 hover:underline text-right bg-transparent border-0 cursor-pointer p-0"
        >
          {{ 'passwordForget.forgotYourPassword' | translate }}
        </button> -->
      </form>
    </div>

    <!-- Footer bar -->
    <div class="flex items-center justify-end gap-2 px-6 py-3 bg-neutral-800">
      <span class="text-neutral-0 text-xs font-medium opacity-70">powered by</span>
      <img alt="SICK" class="h-4" src="assets/images/logo-white.svg" />
    </div>
  </div>
</div>
